import playerStore from '@player/src/store';
import * as playerActionTypes from '@player/src/actionTypes/control';
import { laserBoardEventBus, laserBoardEventsKeys } from '../event-bus-instance';
import { Service } from '@src/slide/infrastructure/module/independent/windows-message-protocol';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IMediaSyncInfo } from '@src/slide/application/service/note-view-media-sync-manager/core/note-view-media-sync-manager.interface';

function getAppServices() {
    return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
}

/**
 * 应该在窗口间同步的事件列表；
 *
 * 禁用的事件包括：
 * - START_PLAY/SLIDE_SCALE_CHANGED/INIT_CLIENT_WIDTHHEIGHT 初始化类事件同步会重复设置
 * - SHOW_DIALOG/SHOW_DIALOG 弹窗只需要在一个 window 中展示
 * - 另外一部分事件从未被使用：如 MASTER_PEN_UPDATED 激光笔相关，NEXT_PAGE_REMOTE 远程演示相关 ...
 */
const syncActionTypes = [
    playerActionTypes.END_PLAY,
    playerActionTypes.NEXT_PAGE,
    playerActionTypes.PREV_PAGE,
    playerActionTypes.NEXT_PAGE_WITHOUT_FRAGMENT,
    playerActionTypes.PREV_PAGE_WITHOUT_FRAGMENT,
    playerActionTypes.JUMP_PAGE,
    playerActionTypes.TURN_ON_LASER,
    playerActionTypes.TURN_OFF_LASER,

    playerActionTypes.JUMP_PAGE_REMOTE,
    playerActionTypes.ALLOW_FLIP_PAGE,
    playerActionTypes.FORIBD_FLIP_PAGE,
    playerActionTypes.SYCN_WITH_MASTER,

    playerActionTypes.INTERACTIVE_ANIM_NEXT,
    playerActionTypes.INTERACTIVE_ANIM_RESET,
    playerActionTypes.STOP_MAIN_ANIM,
];

/** 播放器服务 */
export class PlayerService extends Service {
    public static namespace = 'PresenterView';
    public static voidMethods = ['syncMousemove', 'dispatchAction', 'syncVideoState'];

    /** 同步 player 的 redux action */
    public dispatchAction(action: { type: string }): void {
        if (!syncActionTypes.includes(action.type)) return;

        // 动画会被动触发翻页事件，需要屏蔽；否则多窗口间会造成循环播放；
        if ((action as any).isFirstAnim) return;

        // 标记 action，防止循环 dispatch
        if ((action as any).isDispatchFromService) return;

        // eslint-disable-next-line no-param-reassign
        (action as any).isDispatchFromService = true;
        playerStore.dispatch(action);
    }

    /** 同步鼠标事件 */
    public syncMousemove(point: { X: number; Y: number }): void {
        laserBoardEventBus.emit(laserBoardEventsKeys.DRAW_LASER_CUSOR, point);
    }

    /** 同步视频状态 */
    public syncVideoState(syncVideoInfo: IMediaSyncInfo): void {
        getAppServices().viewableServiceLayer.noteViewMediaSyncManager?.promise().then((ins) => {
            ins.syncVideoState(syncVideoInfo);
        });
    }

    public syncUpdateNote(slideId: string, paragraphList: any, textBodyStyle: any): void {
        const slideList = getAppServices().getUiDataService().slideModelList;
        const targetSlide = slideList.find(slide => slide.id === slideId);
        if (!targetSlide) return;

        targetSlide.noteData.updateParagraphList(paragraphList, textBodyStyle);
    }
}
